import { Resource } from "../resource";

export class Department extends Resource{
    departmentName:  string  | null | undefined;
    departmentId: string | null | undefined;

}